import type {
  IFinanceLeadInitiationEvent,
  IFinanceLeadInitiationInput,
} from '../types/leadEvents';

const financeLeadInitiation = (
  input: IFinanceLeadInitiationInput,
): Omit<IFinanceLeadInitiationEvent, 'event'> => ({
  linkDetails: input.linkDetails ?? { linkName: '' },
  leadDetails: {
    leadOriginationPage: input.leadOriginationPage,
    leadType: input.leadType,
  },
  stepper: {
    step: input.step,
  },
});

export default financeLeadInitiation;
